import { Layout } from "antd";
import { Navigate, useParams } from "react-router";

import { useGetLocation } from "@/entities/location";
import { isError404 } from "@/services/api";

import { LocationPageHeader } from "./location-page-header";
import { LocationPageTabs } from "./location-page-tabs";

const { Content } = Layout;

const LocationPage = () => {
  const { id } = useParams();
  const { isLoading, location, error, removeQuery } = useGetLocation(id ?? "");

  if (isError404(error)) {
    removeQuery();
    return <Navigate to="/locations" />;
  }

  return (
    <>
      <LocationPageHeader location={location} loading={isLoading} />
      <Content>
        <LocationPageTabs location={location} loading={isLoading} />
      </Content>
    </>
  );
};

export default LocationPage;
